/**
 * The LaunchDarkly kill switch in front of the "Report a bug" channel
 * (PSTUDIO-4194).
 *
 * The button opens a modal that sends a message plus screenshots to Sentry, a
 * paid per-event product, so it is gated on an environment basis rather than
 * shipped to every deploy at once. The flag is the SECOND of two conditions —
 * `isErrorReportingActive()` still answers whether a report would reach Sentry
 * at all, and the flag answers whether this environment is meant to offer the
 * channel in the first place.
 */
export const REPORT_BUG_FLAG_KEY = 'ps-report-a-bug';

/**
 * Reads the flag out of the LaunchDarkly flag map.
 *
 * It takes `unknown` on purpose, the same way `readAgentCompilerMode` does:
 * `FeatureFlagsType` is `Record<AvailableFeatureFlagKeys, boolean>` from the
 * GENERATED `@pypestream/feature-flags` types, so indexing it with a key that
 * is not in that union does not type-check — and that file is regenerated from
 * LaunchDarkly rather than hand-edited.
 *
 * Absent, unreadable or non-boolean reads as DISABLED. That is the direction a
 * new channel has to fail in: `app.xstate.ts` hands the app an EMPTY flag map
 * when LaunchDarkly cannot be reached, so a fail-open default would turn every
 * failed LD init into a button that is live everywhere.
 */
export const isReportBugEnabled = (featureFlags: unknown): boolean => {
  if (typeof featureFlags !== 'object' || featureFlags === null) return false;
  return (
    (featureFlags as Record<string, unknown>)[REPORT_BUG_FLAG_KEY] === true
  );
};
